<template>
  <fragment>
    <search-nav-start-end label="작성일" v-model="nav.created_at"/>
    <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes"/>
    <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword"/>
  </fragment>
</template>

<script>
import SearchNavStartEnd from '@/components/nav/SearchNavStartEnd.vue'
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword.vue";

export default {
  name: 'NormalSearchNav103',
  components: {
    SearchNavItemKeyword,
    SearchNavItemSelect,
    SearchNavStartEnd
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler () {
        this.$emit('input', this.nav)
      }
    }
  },
  data () {
    return {
      nav: {
        created_at: '',
        searchType: '',
        searchKeyword: '',
        dateTarget: '',
        dateBegin: '',
        dateEnd: '',
      },
      searchTypes: [
        {value: '사업장명'},
        {value: '종사자 부서'},
        {value: '종사자 성명'},
        {value: '직종'},
        {value: '작성자'},
      ],
    }
  }
}
</script>

<style scoped>

</style>
